<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Cadastros: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  filtrar
        |  e
        strong  abrir
        |  um cadastro em
        strong  Consultas → Cadastros
        | .

      .toast.toast-primary
        | Exige as permissões
        strong  Cadastros → Listar
        |  e
        strong  Cadastros → Exibir
        | . O botão
        strong  Abrir OS
        |  exige
        strong  Ordem serviços → Criar
        | .

      h5.h5 1. Abrir Cadastros
      ol
        li No menu lateral, clique em
          strong  Consultas
          | .
        li Clique em
          strong  Cadastros
          | .
      p Você chega à listagem de cadastros.

      h5.h5 2. Listagem
      p
        | Cada cadastro aparece em um
        strong  card
        |  com tipo e número, situação (ex.: Normal, Cadastro Baixado),
        |  contribuinte e data de alteração.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de Cadastros em Consultas")
      ol
        li Role a lista para ver mais registros.
        li Se houver várias páginas, use a paginação no rodapé.
        li No rodapé de cada card, clique em
          strong  Exibir
          |  (ícone de olho) para abrir o cadastro.

      h5.h5 3. Filtros
      p
        | Acima da lista ficam os filtros (por padrão:
        strong  Número
        |  e
        strong  CPF/CNPJ
        | ), a ordenação e os botões de ação.
      ol
        li Preencha os critérios desejados.
        li Clique no ícone de
          strong  engrenagem
          |  para habilitar ou desabilitar campos adicionais
          |  (razão social, zona, quadra, lote, tipo).
        li Clique na
          strong  lupa
          |  (
          em Filtrar
          | ) para aplicar a busca.

      h5.h5 4. Abrir o cadastro
      ol
        li Na listagem, localize o card desejado.
        li Clique em
          strong  Exibir
          | .
      p
        | A tela do cadastro mostra o número, o tipo e as abas
        strong  Detalhes
        | ,
        strong  Cadastro econômico
        |  (quando houver),
        strong  Sócios
        |  e
        strong  Usuários
        | .
      figure.manual-figure
        img(:src="imgShow" alt="Exibição do cadastro com abas")

      h5.h5 5. Abas e ações do rodapé
      ol
        li Use as abas para ver detalhes, dados econômicos, sócios e usuários.
        li No rodapé você encontra
          strong  E-mails
          | ,
          strong  Logs
          |  (se tiver permissão),
          strong  Abrir OS
          |  e
          strong  Imprimir
          | .
      figure.manual-figure
        img(:src="imgEconomico" alt="Aba Cadastro econômico")
      p
        | A emissão completa de OS fica no manual
        strong  OS-m — Emissão: Nova
        | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/20-consultas-cadastros-lista.png"),
      imgShow: require("@/assets/manuais/20a-consultas-cadastros-show.png"),
      imgEconomico: require("@/assets/manuais/20b-consultas-cadastros-economico.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
